import { Component, OnInit, ViewChild } from '@angular/core';
import { PageHeader } from 'src/app/utils/models/page-header';
import { Module } from '../../models/module';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { ModuleService } from '../../services/module.service';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';

@Component({
  selector: 'app-module',
  templateUrl: './module.component.html',
  styleUrls: ['./module.component.css']
})
export class ModuleComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  private unsubscribe$: Subject<void> = new Subject<void>();
  selectedModule: Module = new Module();
  headerEntity: PageHeader;
  entity: Module = new Module();
  editingEntity: Module = new Module();
  // Modules: Array<Module>;
  ModuleColumns: any[];
  listView: boolean = true;
  formCaption: string = '';
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  Modules: any;
  saveDisabled: boolean = false;
  constructor(
    private _ModuleService: ModuleService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,
    private configService: ConfigService,
  ) {
    this.headerEntity = this.initPageHeader();
    this.ModuleColumns = [

      { field: "SlNo", title: 'SL No', filter: false, sortable: true, width: 150 },
      { field: "Module_Name", title: 'Name', filter: true, sortable: true },

    ];
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.Modules = [];
    this.getAllModules();
  }
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._ModuleService.getAllModules('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1)).subscribe((Modules: Array<Module>) => {
      this.Modules = {
        data: Modules,
        total: Modules[0] ? Modules[0].TotalCount : 0
      }
    });
  }
  getAllModules() {
    this._ModuleService.getAllModules('', Number(this.defaultPageSize), 1).subscribe((Modules: Array<Module>) => {
      this.Modules = {
        data: Modules,
        total: Modules[0] ? Modules[0].TotalCount : 0
      }
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._ModuleService.deleteModule(this.selectedModule.Module_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearModule();
            this.getAllModules();
          },
          )
        }
      }
    });
  }
  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.PageCaption = "MODULE";
    headerEntity.IconClass = "bi bi-app";
    return headerEntity;
  }
  deleteModule(event: any) {
    if (event.seletedRows[0]) {
      this.selectedModule.Module_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Module",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  addModule(event: any) {
    this.listView = false;
    this.clearModule();
    this.formCaption = "Add New Module";
  }
  editModule(event: any): void {
    if (event.seletedRows[0]) {
      // let editModule = this.Modules.find(x => x.Module_Id === event.seletedRows[0]);
      this._ModuleService.viewModule(event.seletedRows[0]).subscribe((Modules: Array<Module>) => {
        let editModule = Modules[0] ? Modules[0] : new Module();
        if (editModule) {
          this.editingEntity = editModule;
          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Module";
          this.entity.EntityMetaData = [
            { FieldName: 'Module_Name', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Name is required' }
          ];
        }
      });
    }
  }

  save(event: any): void {
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._ModuleService.checkDuplication(this.entity.Module_Name, this.entity.Module_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Module already exists');
          this.saveDisabled = false;
        }
        else {
          this._ModuleService.saveModule(this.entity).subscribe(() => {
            if (this.entity.Module_Id == "") {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearModule();
            this.getAllModules();
          })
        }
      });
    }
  }
  gotoBack(): void {
    this.listView = true;
  }
  refreshModule(event: any): void {
    this.Modules = [];
    this.getAllModules();
  }
  clearModule(): void {
    this.entity = new Module();
    this.saveDisabled = false;
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  onExcelExport() {
    this.excelexport.save()
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
